import React from "react";
import get from "lodash/get";
import { withNamespaces } from "react-i18next";
import FileLink from "../FileLink/FileLink";
import { getUserToken } from "../../reducers/user/selectors";
import { connect } from "react-redux";

const ConsentMevoStep4 = (props) => {
  let isEmailMethodConsent = get(props, "consentMethodType", '').toLowerCase().indexOf("email") !== -1;

  let emailStatusMessage = props.i18n.t(
              "NamespaceConsent:Confirmation - Consent has been provided!"
            );
  if (isEmailMethodConsent){
    if (props.consentExistsEmailStatus !== 'all_signatures_collected'){
      if (props.consentExistsEmailStatus === 'investigator_email_sent' || (props.consentExistsEmailStatus === 'participant_signed' && props.email_consent_signature_order === 'subject_first')){
        emailStatusMessage = props.i18n.t('NamespaceConsent:Confirmation - E-mail Consent has been sent to investigator for signature!');
      }
      if (props.consentExistsEmailStatus === 'participant_email_sent' || (props.consentExistsEmailStatus === 'investigator_signed' && props.email_consent_signature_order !== 'subject_first')){
        emailStatusMessage = props.i18n.t('NamespaceConsent:Confirmation - E-mail Consent has been sent to participant for signature!');
      }
    }
  }

  return (
    <div className="form-group">
      <div className="form-group-details">
        <h4>
          {emailStatusMessage}
        </h4>
        {props.siteID && (
          <h5>
            {props.i18n.t("NamespaceConsent:Site ID")}: <b>{props.siteID}</b>
          </h5>
        )}
        {props.userID && (
          <h5>
            {props.i18n.t("NamespaceConsent:User ID")}: <b>{props.userID}</b>
          </h5>
        )}
        <h5>
          {props.i18n.t("NamespaceConsent:Subject ID")}: <b>{props.subjectID}</b>
        </h5>
        <h5>
          {props.i18n.t("NamespaceConsent:Consent Type")}: <b>{props.consentPersonType}</b>
        </h5>
        <h5>
          {props.i18n.t("NamespaceConsent:Consent Method")}: <b>{props.consentMethodType}</b>
        </h5>

        {props.consent_version && (
          <h5 style={{ display: "inline-block !important" }}>
            {props.i18n.t("NamespaceConsent:Consent Version")}: <b>{props.consent_version}</b>
          </h5>
        )}
        {props.consentExistsOption && (
          <h5 style={{ display: "inline-block !important" }}>
            {props.i18n.t("NamespaceConsent:Consent Options")}:{" "}
            <b>{props.consentExistsOption.replace(/_/g, " ")}</b>
          </h5>
        )}

        {isEmailMethodConsent &&
          props.consentExistsEmailStatus && (
            <h5>
              {props.i18n.t("NamespaceConsent:Consent Email Status")}:{" "}
              <b>{props.consentExistsEmailStatus.replace(/_/g, " ")}</b>
            </h5>
          )}
        {props.token &&
          props.consentExistsLink &&
          (Array.isArray(props.consentExistsLink) ? (
            props.consentExistsLink.map(({ link, name }) => (
            link ? <h5>
                {props.i18n.t("NamespaceConsent:Document Link")}:{" "}
                <b style={{ position: "relative", top: "8px" }}>
                  <FileLink url={link} text={name} />
                </b>
              </h5> : <div />
            ))
          ) : (
          props.consentExistsLink.link ? <h5>
              {props.i18n.t("NamespaceConsent:Document Link")}:{" "}
              <b style={{ position: "relative", top: "8px" }}>
                <FileLink
                  url={props.consentExistsLink.link}
                  text={props.consentExistsLink.name}
                />
              </b>
            </h5> : <div/>
          ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: getUserToken(state),
});

export default connect(mapStateToProps)(withNamespaces()(ConsentMevoStep4));



// WEBPACK FOOTER //
// ./src/components/ConsentTypeMevoV2/ConsentMevoStep4.js